import { render, staticRenderFns } from "./sysPerm.vue?vue&type=template&id=74575bcb&scoped=true&"
import script from "./sysPerm.vue?vue&type=script&lang=js&"
export * from "./sysPerm.vue?vue&type=script&lang=js&"
import style0 from "./sysPerm.vue?vue&type=style&index=0&id=74575bcb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74575bcb",
  null
  
)

export default component.exports